import { type ReactNode } from "react";

export const TwoLineOptionLabel = ({
  title,
  subtitle
}: {
  title: ReactNode;
  subtitle?: ReactNode;
}) => (
  <div className="flex flex-col">
    <span className="text-sm font-medium leading-4 text-content-1000">
      {title}
    </span>
    {subtitle ? (
      <span className="text-[10px] font-medium leading-3 text-content-300">
        {subtitle}
      </span>
    ) : null}
  </div>
);
